export class GeneralResModel<T> {
  Result: T;
  Message: string;
  IsSucceed: boolean;
  IsDuplicated: boolean;
  HttpStatusCode: number;
  IsNotFound: boolean;
}
